var map = {
	"./Race_Antuk.png": 535,
	"./Race_Krakee.png": 536,
	"./Race_Mantah.png": 537,
	"./Race_Montak.png": 538,
	"./Race_Muu.png": 539,
	"./Race_None.png": 540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 278;